import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import './assets/layout/flags/flags.css';
import './assets/layout/layout.scss';
import './App.css';

import 'react-app-polyfill/ie11';
import { createRoot } from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { addLocale } from 'primereact/api';
import ScrollToTop from './ScrollToTop';

import { AppToast } from './AppToast';
import { AppConfirmDialog } from './AppConfirmDialog';
import { AppInfoDialog } from './AppInfoDialog';
import { AppLoading } from './AppLoading';

import App from './app';
import Login from './pages/login';
import ForgotPassword from './pages/forgot-password';
import BangGiaVang from './pages/bang-gia-vang';

addLocale('en', {
  noFilter: 'Bỏ tìm kiếm'
});

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <HashRouter>
    <AppToast />
    <AppConfirmDialog />
    <AppInfoDialog />
    <AppLoading />
    <ScrollToTop>
      <Routes>
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="*" element={<App />} />
        <Route path="bang-gia" element={<BangGiaVang />} />
      </Routes>
    </ScrollToTop>
  </HashRouter>
);

export * from './shared/language';

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
//serviceWorker.unregister();
